module.exports = __webpack_public_path__ + "img/kharkivenergozbut.0071ca65.png";